import React from 'react';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import AnalyticsWrapper from '@configuratorware/configurator-frontendgui/App/Shared/Components/Analytics/AnalyticsWrapper';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { IconButton, useMediaQuery } from '@material-ui/core';

const StyledButton = withStyles({
  root: {
    borderRadius: 0,
  },
  startIcon: {
    marginLeft: 0,
  },
  iconSizeLarge: {
    '& > *:first-child': {
      fontSize: 28,
    },
  },
})(Button);

export const PDFDownload = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  return (
    <AnalyticsWrapper targetId={'picture_as_pdf'}>
      {isMobile ? (
        <IconButton color="inherit" size="large" onClick={() => Services.interaction.printConfigurationAndOpenPdf()}>
          <PictureAsPdfIcon />
        </IconButton>
      ) : (
        <StyledButton
          size="large"
          startIcon={<PictureAsPdfIcon />}
          onClick={() => Services.interaction.printConfigurationAndOpenPdf()}
        >
          {t('headerMenu.saveAsPdf')}
        </StyledButton>
      )}
    </AnalyticsWrapper>
  );
};

export default PDFDownload;
